export const billingReconKeys = {
  root: ['billingRecon'],
  runs: ({ program, serviceMonth, limit, offset } = {}) => [
    'billingRecon',
    'runs',
    program || null,
    serviceMonth || null,
    limit || null,
    offset || null,
  ],
  varianceListScope: ({ runId } = {}) => ['billingRecon', 'variances', runId || null],
  variances: ({ runId, includeExternalContext, externalContextMode, driver, reviewed, search, limit, offset } = {}) => [
    'billingRecon',
    'variances',
    runId || null,
    includeExternalContext ?? null,
    externalContextMode || null,
    driver || null,
    reviewed ?? null,
    search || null,
    limit || null,
    offset || null,
  ],
  varianceCompletionReadiness: ({ runId, varianceId } = {}) => ['billingRecon', 'varianceCompletionReadiness', runId || null, varianceId || null],
  fileHealth: ({ runId, bac, tier, search, openOnly, limit, offset }) => ['billingRecon', 'fileHealth', runId || null, bac || null, tier || null, search || null, openOnly ?? null, limit || null, offset || null],
  fileHealthSummary: ({ runId, bac, tier, summaryMode, summary_mode } = {}) => [
    'billingRecon',
    'fileHealthSummary',
    runId || null,
    bac || null,
    tier || null,
    summaryMode || summary_mode || null,
  ],
  alerts: ({ runId, severity, dismissed, limit, offset }) => ['billingRecon', 'lifecycleAlerts', runId || null, severity || null, dismissed ?? null, limit || null, offset || null],
  credits: ({ runId, limit, offset }) => ['billingRecon', 'credits', runId || null, limit || null, offset || null],
  actions: ({ varianceId }) => ['billingRecon', 'varianceActions', varianceId || null],
  actionSummary: ({ runId }) => ['billingRecon', 'actionSummary', runId || null],
  exportPreview: ({
    runId,
    lane,
    domain,
    mutation,
    status,
    binding,
    search,
    limit,
    offset,
    view,
    roundMode,
    roundNumber,
    includeSuperseded,
  } = {}) => [
    'billingRecon',
    'exportPreview',
    runId || null,
    lane || null,
    domain || null,
    mutation || null,
    status || null,
    binding || null,
    search || null,
    limit || null,
    offset || null,
    view || null,
    roundMode || null,
    roundNumber || null,
    includeSuperseded || null,
  ],
  noteTemplates: ({ scope, active, limit, offset } = {}) => ['billingRecon', 'noteTemplates', scope || null, active ?? null, limit || null, offset || null],
  exports: ({ runId, lane, limit, offset } = {}) => ['billingRecon', 'exports', runId || null, lane || null, limit || null, offset || null],
};
